export default __webpack_public_path__ + "static/media/Comercial.44cb3cde.mp4";